var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"98d85cd-1773835489"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/production";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { isProductionEnv } from '~/lib/env';

Sentry.init({
  dsn: 'https://ucmjESrRTGf5gdrnvVmSs2Yf@s1628254.eu-nbg-2.betterstackdata.com/1628254',
  enabled: isProductionEnv(),

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Filter out errors from third-party scripts that we can't control
  beforeSend(event, hint) {
    const error = hint.originalException;
    const errorMessage = error instanceof Error ? error.message : String(error);

    // Ignore generic "Failed to fetch" errors from third-party scripts (Plasmic, Customer.io, etc.)
    // These are typically caused by network issues, ad blockers, or bot browsers
    if (errorMessage === 'Failed to fetch' || errorMessage === 'TypeError: Failed to fetch') {
      // Check stack trace for Plasmic-related function names (may be minified in production)
      const stackString = error instanceof Error ? error.stack || '' : '';
      const isThirdPartyFetch =
        stackString.includes('fetchLoaderData') || // Plasmic
        stackString.includes('maybeFetchComponentData') || // Plasmic
        stackString.includes('fetchMissingData') || // Plasmic
        stackString.includes('plasmicapp') || // Plasmic domain in stack
        stackString.includes('loader-nextjs'); // Plasmic loader package
      if (isThirdPartyFetch) {
        return null;
      }
      
      // Also check event frames for third-party origins
      const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
      const hasThirdPartyFrame = frames.some((frame) =>
        frame.filename?.includes('plasmicapp') ||
        frame.filename?.includes('customer.io') ||
        frame.filename?.includes('cdn.adfenix.com')
      );
      if (hasThirdPartyFrame) {
        return null;
      }
    }

    // Ignore Adfenix/Realforce tracker errors (204/403 response parsing)
    if (errorMessage.includes('Error parsing JSON response')) {
      return null;
    }

    // Ignore errors originating from third-party domains
    const thirdPartyPatterns = [
      'adfenix.com',
      'plasmic.app',
      'customer.io',
      'posthog.com',
      'google-analytics.com',
    ];

    const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
    const isThirdPartyError = frames.some((frame) =>
      thirdPartyPatterns.some((pattern) => frame.filename?.includes(pattern))
    );

    if (isThirdPartyError) {
      return null;
    }

    return event;
  },

  // Note: Replay is not supported by Better Stack, only error tracking
});
